<template>
    <div class="story-maker-sticker story-maker-sticker-text" :class="{edit : isEditing}" @click="()=>{if(isEditing) $refs[`textEditable`].focus()}">
       
        <p class="text-finish" @click="()=>finish()">Terminé</p>
        <div class="sticker sticker-text"
            :style="{ 
                top: `${$attrs.position.y}%`, 
                left: `${$attrs.position.x}%`,
                transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : '',
                textAlign: `${models.align}`,
            }"
        >
            <p
                :contenteditable="isEditing"
                @input="handlerInput"
                ref="textEditable"
                v-html="models.text"
                spellcheck="false"
                class="textarea"
                :class="`${models.font} ${models.align}`"
                :style="{
                    fontSize: `${15 + models.cursor / 10}px`,
                    textAlign: `${models.align}`,
                    color: models.background == 'primary' ? secondaryColor : models.color,
                    backgroundColor: models.background == 'none' ? '' : models.background == 'secondary' ? secondaryColor : models.color,
                    boxShadow: models.background == 'none' || textEmpty ? '' : `
                        ${models.background == 'secondary' ? secondaryColor : models.color} 0.4em 0px 0px 0.28em, 
                        ${models.background == 'secondary' ? secondaryColor : models.color} -0.4em 0px 0px 0.28em, 
                        ${models.background == 'secondary' ? secondaryColor : models.color} 0px 0px 0px 0.28em
                    `,
                    //padding: textEmpty ? '' : `${(15 + models.cursor / 10) * 0.20}px ${(15 + models.cursor / 10) * 0.40}px`,
                    //borderRadius: `1px`,
                    //borderRadius: `${(15 + models.cursor / 10) * 0.28}px`
                }"
            ></p>
        </div>              

        <div class="container-cursor-size">
            <div class="cursor-size">
                <input v-model="models.cursor" type="range" min="0" max="350">
                <svg width="auto" height="auto" viewBox="0 0 80 794" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M40 793L1 1H79L40 793Z" fill="#CBCBCD" stroke="#CBCBCD" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
        
        <div class="container-action">
            <div class="list-option">
                <div v-if="actionSelected == 'font'" class="list-option-text hide-scrollbar">
                    <div class="texts">
                        <div class="text modern modern-font" :class="{active : models.font == 'modern-font'}" @click="models.font = 'modern-font'">Modern</div>
                        <div class="text classic classic-font" :class="{active : models.font == 'classic-font'}" @click="models.font = 'classic-font'">Classic</div>
                        <div class="text signature signature-font" :class="{active : models.font == 'signature-font'}" @click="models.font = 'signature-font'">Signature</div>
                        <div class="text editor editor-font" :class="{active : models.font == 'editor-font'}" @click="models.font = 'editor-font'">Editor</div>
                        <div class="text poster poster-font" :class="{active : models.font == 'poster-font'}" @click="models.font = 'poster-font'">Poster</div>
                        <div class="text bubble bubble-font" :class="{active : models.font == 'bubble-font'}" @click="models.font = 'bubble-font'">Bubble</div>
                        <div class="text deco deco-font" :class="{active : models.font == 'deco-font'}" @click="models.font = 'deco-font'">Deco</div>
                        <div class="text squeeze squeeze-font" :class="{active : models.font == 'squeeze-font'}" @click="models.font = 'squeeze-font'">Squeeze</div>
                        <div class="text typewriter typewriter-font" :class="{active : models.font == 'typewriter-font'}" @click="models.font = 'typewriter-font'">Typewriter</div>
                        <div class="text strong strong-font" :class="{active : models.font == 'strong-font'}" @click="models.font = 'strong-font'">Strong</div>
                        <div class="text meme meme-font" :class="{active : models.font == 'meme-font'}" @click="models.font = 'meme-font'">Meme</div>
                        <div class="text elegant elegant-font" :class="{active : models.font == 'elegant-font'}" @click="models.font = 'elegant-font'">Elegant</div>
                        <div class="text directional directional-font" :class="{active : models.font == 'directional-font'}" @click="models.font = 'directional-font'">Directional</div>
                        <div class="text literature literature-font" :class="{active : models.font == 'literature-font'}" @click="models.font = 'literature-font'">Literature</div>
                    </div>
                </div>

                 <div v-else-if="actionSelected == 'color'" class="list-option-color">
                    <div class="pipette">
                        <div class="icon" :style="{backgroundColor: pickerColors.hex}" @click="()=>{ models.color = pickerColors.hex; colorPickerShow = true; showPipette = true}">

                        <div class="picker-color" v-if="colorPickerShow" @mouseleave="colorPickerShow = false" @mousedown="showPipette = false">
                            <div class="icon-pipette" v-if="eyeDropperIsAccess && showPipette" @mousedown.stop @click.stop="startEyeDropper"></div>
                            <chrome-picker :value="pickerColors" @input="updateFromPicker"/>
                        </div>
                        
                    </div></div>
                    <div class="color-carousel">
                        <carousel :perPage="1" :adjustableHeight="true" :centerMode="true" @pageChange="()=>{}" >
                            <Slide v-for="(colors,index) in [['#FFFFFF','#000000','#4397EF','#70C04F','#F6CB5B','#F08C34','#EA4857','#D12D69','#B100C0'],['#EA3323','#ED858E','#F7D0D1','#FADAB4','#F5C281','#D18E47','#99643A','#432324','#1D4A29'],['#262626','#363636','#555555','#737373','#999999','#B2B2B2','#C7C7C7','#DBDBDB','#EFEFEF']]" :key="index">
                                <div v-for="colorHexa in colors" class="color" :style="`background-color:${colorHexa}`" @click="()=>{models.color = colorHexa; pickerColors.hex = colorHexa}"></div>
                            </Slide>
                        </carousel>
                            
                    </div>
                 </div>
            </div>
            <div class="list-action">
                <div class="action font" :class="{active : actionSelected == 'font'}" @click="actionSelected = 'font'">
                    <div class="icon"></div>
                </div>
                <div class="action color" :class="{active : actionSelected == 'color'}" @click="actionSelected = 'color'">
                    <div class="icon"></div>
                </div>
                <div class="action align" :class="`${models.align}`" @click="models.align = {'center':'start','start':'end','end':'center'}[models.align]">
                    <div class="icon"></div>
                </div>
                <div class="action background" :class="`${models.background}`" @click="models.background = {'secondary':'primary','primary':'none','none':'secondary'}[models.background]">
                    <div class="icon"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import { Chrome } from 'vue-color'
import { getLuminanceColor, adjustColorBrightness, hex2rgb, increase_brightness } from '../../../../../utils/Color.js'

export default {

    components: {
        Carousel,
        Slide,
        'chrome-picker': Chrome,
    },

    props: {
        id: [Number, String],
        isEditing: Boolean,
        text: String,
        font: String,
        fontSize: Number,
        align: String,
        color: String,
        background: String,
        isPreventCover: Boolean,
        isCover: Boolean,
        setCover: Function,
        setCbClick: Function,
    },
    
    data() {
        return {
            actionSelected: 'font',
            models: {
                text: '',
                font: '',
                cursor: 125,
                align: 'center',
                background: 'secondary',
                color: '#000'
            },
            //cursorPosition: null,
            timeoutFinish: null,
            colorPickerShow: false,

            pickerColors: {
				hex: '#000000',
			},
            
            eyeDropperIsAccess : false,
            showPipette : true,
            textEmpty : true,
        }
    },

    mounted () {
        if (this.setCbClick) this.setCbClick(this.clickSticker);
        
        this.eyeDropperIsAccess = window.EyeDropper ? true : false

        if(this.isEditing) this.$refs[`textEditable`].focus()
    },
    
    methods: {
        clickSticker() {
            if (this.isEditing) return 
            this.setCover(true)

            this.$nextTick(()=> {
                this.$emit('updateSticker',this.id , {
                    isEditing: true
                })   
            })
        },
        finish() {

            if (this.$refs[`textEditable`].innerText.length) {
                this.$emit('updateSticker',this.id , {
                    isEditing: false,
                    data : {
                        text: this.$refs[`textEditable`].innerHTML,
                        font: this.models.font,
                        align: this.models.align,
                        color: this.models.color,
                        background: this.models.background,
                        fontSize: 15 + parseInt(this.models.cursor) / 10
                    },
                })
            }else{
                this.$emit('deleteSticker',this.id)
            }
          

            if (this.timeoutFinish) clearTimeout(this.timeoutFinish)
            this.timeoutFinish = setTimeout(() => {
                this.setCover(false)
            }, 200);
        },

        updateFromPicker(value) {
            this.pickerColors = {
                hex: value.hex
            }
            this.models.color = value.hex
        },

        handlerInput(e) {
            this.textEmpty = e.target.innerText == 0  
            // this.models.text = e.target.innerHTML  
        },

        startEyeDropper() {
            if (!window.EyeDropper) return
            this.colorPickerShow = false
            const eyeDropper = new EyeDropper();

            eyeDropper.open().then((result) => {
                this.models.color = result.sRGBHex
                this.pickerColors = {
                    hex: result.sRGBHex
                }
            }).catch((e) => {
            });
        }  
    },

    computed: {
        secondaryColor() {
            const rbgColorObject = hex2rgb(this.models.color)

            if (rbgColorObject.r == 255 && rbgColorObject.g == 255 && rbgColorObject.b == 255) return '#000000'
            if (rbgColorObject.r == 0 && rbgColorObject.g == 0 && rbgColorObject.b == 0) return '#FFFFFF'

            console.log('rbgColorObject',rbgColorObject, this.models.color)
            return getLuminanceColor(...Object.values(rbgColorObject)) > 0.78 ? 
                increase_brightness(...adjustColorBrightness(...Object.values(rbgColorObject),0.1),10)
                : increase_brightness(...Object.values(rbgColorObject), 80)
        }
    },

    watch: {
        text: {
            handler(newValue) {
                this.models.text = newValue
                if (newValue) this.textEmpty = false
            },
            immediate: true
        },
        font: {
            handler(newValue) {
                this.models.font = newValue
            },
            immediate: true
        },
        align: {
            handler(newValue) {
                this.models.align = newValue
            },
            immediate: true
        },
        color: {
            handler(newValue) {
                this.models.color = newValue
            },
            immediate: true
        },
        background: {
            handler(newValue) {
                this.models.background = newValue
            },
            immediate: true
        },
        fontSize: {
            handler(newValue) {
                this.models.cursor = (newValue - 15) * 10
            },
            immediate: true
        }
    },

    
}
</script>
